module.exports = __webpack_public_path__ + "images/emoji/waxing_gibbous_moon.42c7f5dbe39b95fbd73b.png";